import { Button } from "@geely/ui";
import { Plus } from 'lucide-react';
import { AdminLayout } from '@/app/components/AdminLayout';
import { PageHeader, PageLoading } from '@/app/components/shared';
import { TablePagination } from '@/app/components/shared/TablePagination';
import { UsersTable, UserFormDialog } from './components';
import { useUsersData } from './hooks';

export function UsersPage() {
  const {
    users,
    stores,
    isLoading,
    paginationMeta,
    setPage,
    isDialogOpen,
    editingUser,
    handleOpenDialog,
    handleCloseDialog,
    handleSubmit,
    handleDelete,
    getStoreNames,
  } = useUsersData();

  if (isLoading) {
    return <PageLoading message="Carregando usuários..." />;
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <PageHeader
          title="Gerenciar Usuários"
          subtitle="Cadastre e gerencie os usuários do sistema"
          actions={
            <Button onClick={() => handleOpenDialog()}>
              <Plus className="size-4 mr-2" />
              Novo Usuário
            </Button>
          }
        />

        <UsersTable
          users={users}
          getStoreNames={getStoreNames}
          onEdit={handleOpenDialog}
          onDelete={handleDelete}
        />

        {paginationMeta && (
          <TablePagination meta={paginationMeta} onPageChange={setPage} />
        )}

        <UserFormDialog
          isOpen={isDialogOpen}
          editingUser={editingUser}
          stores={stores}
          onSubmit={handleSubmit}
          onClose={handleCloseDialog}
        />
      </div>
    </AdminLayout>
  );
}
